/*
  How Gifting Works page behaviour (sections/hgw-*.liquid).

  Motion (skipped under prefers-reduced-motion and in the theme editor):
  - gentle fade-up on scroll for [data-hgw-reveal]
  - slow float on the hero illustration [data-hgw-float]
  - handwriting on the hero bubble [data-hgw-writing]: each phrase is revealed left to right by a
    soft pen mask, held, faded out, then the next phrase is written. Paused while off-screen.

  Swipe rows (always on): on mobile the Steps and Personal cards scroll sideways ([data-hgw-swipe]);
  the dots below ([data-hgw-dots]) follow the scroll position and jump to a card when tapped.

  Every hgw section loads this file, so it guards against running more than once.
*/
(function () {
  if (window.__hgwMotion) return;
  window.__hgwMotion = true;

  var WRITE_MS = { amani: 1700, zawadi: 1800, 'happy-birthday': 2100, 'with-love': 1900 };
  var HOLD_MS = 2000;
  var FADE_MS = 600;
  var GAP_MS = 350;

  function wait(el, ms) {
    return el.animate([{ opacity: 1 }, { opacity: 1 }], { duration: ms });
  }

  function initWriting(root) {
    var phrases = Array.prototype.slice.call(root.querySelectorAll('[data-hgw-phrase]'));
    if (phrases.length < 2) return;

    var current = null;
    var onScreen = true;

    function run(animation) {
      current = animation;
      if (!onScreen) animation.pause();
      return animation.finished;
    }

    new IntersectionObserver(function (entries) {
      onScreen = entries[0].isIntersecting;
      if (!current) return;
      if (onScreen) current.play();
      else current.pause();
    }).observe(root.closest('svg') || root);

    function pensFor(phrase) {
      return Array.prototype.map.call(phrase.querySelectorAll('[mask]'), function (path) {
        var id = path.getAttribute('mask').replace(/^url\(#|\)$/g, '');
        return root.querySelector('#' + id + ' [data-hgw-pen]');
      });
    }

    async function write(phrase) {
      var pens = pensFor(phrase);
      var lengths = pens.map(function (pen) {
        return parseFloat(pen.getAttribute('data-length'));
      });
      var total = lengths.reduce(function (a, b) {
        return a + b;
      }, 0);
      pens.forEach(function (pen, i) {
        pen.getAnimations().forEach(function (a) {
          a.cancel();
        });
        pen.style.strokeDasharray = lengths[i];
        pen.style.strokeDashoffset = lengths[i];
      });
      phrase.getAnimations().forEach(function (a) {
        a.cancel();
      });
      phrase.setAttribute('visibility', 'visible');

      var duration = WRITE_MS[phrase.getAttribute('data-hgw-phrase')] || 1800;
      for (var i = 0; i < pens.length; i++) {
        if (i > 0) await run(wait(phrase, 150));
        await run(
          pens[i].animate([{ strokeDashoffset: lengths[i] }, { strokeDashoffset: 0 }], {
            duration: Math.round((duration * lengths[i]) / total),
            easing: 'cubic-bezier(0.45, 0.05, 0.55, 0.95)',
            fill: 'forwards',
          })
        );
      }
    }

    async function loop() {
      var index = 0;
      // Amani is already on the bubble at load, so start with its hold.
      await run(wait(phrases[0], HOLD_MS));
      for (;;) {
        await run(phrases[index].animate([{ opacity: 1 }, { opacity: 0 }], { duration: FADE_MS, easing: 'ease-in', fill: 'forwards' }));
        phrases[index].setAttribute('visibility', 'hidden');
        await run(wait(phrases[index], GAP_MS));
        index = (index + 1) % phrases.length;
        await write(phrases[index]);
        await run(wait(phrases[index], HOLD_MS));
      }
    }

    loop().catch(function () {
      /* animation cancelled (e.g. section re-rendered); stop quietly */
    });
  }

  function initMotion() {
    if (window.Shopify && window.Shopify.designMode) return;
    if (!window.matchMedia || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!Element.prototype.animate) return;

    document.querySelectorAll('[data-hgw-float]').forEach(function (el) {
      el.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(-10px)' }], {
        duration: 3200,
        direction: 'alternate',
        iterations: Infinity,
        easing: 'ease-in-out',
      });
    });

    if (!('IntersectionObserver' in window)) return;

    document.querySelectorAll('[data-hgw-writing]').forEach(initWriting);

    var hidden = new Map();
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var a = hidden.get(e.target);
          if (a) a.cancel();
          e.target.animate([{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'none' }], {
            duration: 650,
            easing: 'ease-out',
          });
          io.unobserve(e.target);
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll('[data-hgw-reveal]').forEach(function (el) {
      // Anything already on screen at load stays visible; only content below the fold fades up.
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      hidden.set(el, el.animate([{ opacity: 0 }], { fill: 'forwards' }));
      io.observe(el);
    });
  }

  function initSwipe(scope) {
    scope.querySelectorAll('[data-hgw-swipe]').forEach(function (row) {
      if (row.__hgwSwipe) return;
      row.__hgwSwipe = true;
      var dots = row.parentElement.querySelector('[data-hgw-dots]');
      if (!dots) return;
      var buttons = Array.prototype.slice.call(dots.querySelectorAll('button'));
      var cards = Array.prototype.slice.call(row.children);

      function activeIndex() {
        var start = row.getBoundingClientRect().left + parseFloat(getComputedStyle(row).scrollPaddingLeft || 0);
        var best = 0;
        var bestDistance = Infinity;
        cards.forEach(function (card, i) {
          var d = Math.abs(card.getBoundingClientRect().left - start);
          if (d < bestDistance) {
            bestDistance = d;
            best = i;
          }
        });
        return best;
      }

      function update() {
        var index = activeIndex();
        buttons.forEach(function (button, i) {
          button.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      var frame = null;
      row.addEventListener(
        'scroll',
        function () {
          if (frame) return;
          frame = requestAnimationFrame(function () {
            frame = null;
            update();
          });
        },
        { passive: true }
      );

      buttons.forEach(function (button, i) {
        button.addEventListener('click', function () {
          var card = cards[i];
          if (!card) return;
          var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
          row.scrollTo({
            left: card.offsetLeft - row.firstElementChild.offsetLeft,
            behavior: reduce ? 'auto' : 'smooth',
          });
        });
      });

      update();
    });
  }

  function init() {
    initSwipe(document);
    initMotion();
  }

  // Customizer: re-bind swipe dots when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    initSwipe(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
